module.exports = __webpack_public_path__ + "img/badge-blank.7bd8becf.png";